export const CONTENT_TYPES = {
  OVERVIEW: 'overview',
  OVERVIEW_COLLECTION: 'overviewCollection',
  CLIP: 'clip',
  PODCAST: 'podcast',
  PODCAST_COLLECTION: 'podcastCollection',
  SHOW: 'show',
  STATION: 'station',
  STATION_PAGE: 'stationPage',
  TRACK: 'track',
  BANNER: 'banner',
  CALL_TO_ACTION_BLOCK: 'call-to-action',
  CARD: 'card',
  MIXED_COLLECTION: 'mixedCollection',
  SHOW_COLLECTION: 'showCollection',
  SCHEDULES: 'schedules',
  ONDEMAND_TILE: 'ondemand-tile',
  SHOW_TILE: 'show-tile',
  STATION_TILE: 'station-tile',
  PROMOTION_COLLECTION: 'promotionCollection',
  PROMOTION: 'promotion',
  CAMPAIGN: 'campaign',
  STATION_COLLECTION: 'stationCollection',
  TAG_COLLECTION: 'tagCollection',
  ON_DEMAND_COLLECTION: 'onDemandCollection',
  RECENTLY_PLAYED_STATIONS_COLLECTION: 'recentlyPlayedStationsCollection',
  TABS: 'tabs',
  RANDOM_STATION: 'randomStation',
};

export { CONTENT_TYPES as default };
